import { Injectable } from "@angular/core";
import { RestServiceBase } from "@definitiv-packages/angular-dba-library";
import { SysLandModel } from "../../../public-api";
import { SysServiceRythmusModel } from "../../types/SysServiceRythmusModel";

@Injectable({
    providedIn: 'root'
})
export class SysServiceRythmusService extends RestServiceBase<SysServiceRythmusModel> {
    constructor(
    ) {
        super("SysServiceRythmusModel", false);
    }
}